import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ─── Video (image-to-video) ──────────────────────────────────
// Animate a rendered storyboard frame into a short clip (Google Veo via fal).

/** Submit an animate-frame job. Returns the video_jobs record (status 'queued'). */
export async function animateFrame(payload) {
  const { data } = await axios.post(`${API}/video/animate`, payload);
  return data;
}

/** Poll a video job by id. Returns the record (status + video_url when ready). */
export async function getVideoJob(videoId) {
  const { data } = await axios.get(`${API}/video/${videoId}`);
  return data;
}

/** List video jobs for a project. */
export async function listVideoJobs(projectId) {
  const { data } = await axios.get(`${API}/video/project/${projectId}`);
  return data;
}
